module.exports = new __parcel__URL__("ImportErrorIllustration.db4fa603.svg").toString();